// extracted by mini-css-extract-plugin
export default {"title":"BillingPartSummary_title__UCKQ1"};